import React, { useEffect, useState } from 'react'
import { Pie } from 'react-chartjs-2';
import { Chart, registerables } from 'chart.js';
import { BiPieChart } from 'react-icons/bi'
import utils from '../../utils';

function HouseCategoryChart(props) {
    Chart.register(...registerables);
    const houseData = props.chartData
    const [chartData, setChartData] = useState()

    useEffect(() => {
        if (houseData?.house_category_aggregate) {
            setChartData({
                labels: houseData?.house_category_aggregate.map((item) => (item?.category__name)),
                datasets: [{
                    label: 'Houses Category Chart',
                    data: houseData?.house_category_aggregate.map((item) => (item.count)),               
                }],
            })
        }
    }, [houseData])
    useEffect(() => {}, [chartData])
    return (
        <div className='bg-base-100 rounded-md p-3'>
            <div className="flex mb-3">
                <BiPieChart className='font-bold text-2xl mr-3'/>
                <p className="font-bold">House Category Chart</p>
            </div>
            <div className="chart">
                <div style={{"height": "45vh", "width": "100%"}}>
                    {chartData && (
                        <Pie
                            data={chartData}
                            options={utils.chartOptions}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

export default HouseCategoryChart